import { standardCode, productLandingCode, standardLandingCode } from './footersCode';
import { standardLayout, productLandingLayout, standardLandingLayout } from './footersLayouts';

import styles from '../Footers.css';

export const footersSet = [
  {
    component: standardLayout,
    codeTemplate: standardCode,
    imagePath: 'default.png',
    modalPreviewClassName: 'with-padding',
    optionsGroup: [
      {
        label: 'Standard', options: [
          { label: 'default', type: 'radio', options: {bgColor: 'black'}},
        ]
      },
    ]
  },
  {
    component: productLandingLayout,
    codeTemplate: productLandingCode,
    imagePath: 'productLanding.png',
    modalPreviewClassName: 'with-padding',
    optionsGroup: [
      {
        label: 'Product Landing Page', options: [
          { label: 'default', type: 'radio', options: {bgColor: 'black'}},
        ]
      },
    ]
  },
  {
    component: standardLandingLayout,
    codeTemplate: standardLandingCode,
    imagePath: 'standardLanding.png',
    previewClassName: styles.standardLandingPreview,
    optionsGroup: [
      {
        label: 'Standard Landing Page', options: [
          { label: 'default', type: 'radio', options: {bgColor: 'black'}},
        ]
      },
    ]
  },
];




// WEBPACK FOOTER //
// ./src/containers/components/Footer/constants/footersSet.js